import { GatewayPlacement } from '@lib/api';
import { TOption } from '@lib/util';
import i18next from 'i18next';

export const gatewayPlacementOptions: TOption<GatewayPlacement>[] = [
  { label: i18next.t('gateway_placement.basement', { ns: 'enums' }), value: 'Basement' },
  { label: i18next.t('gateway_placement.basement_heating_room', { ns: 'enums' }), value: 'BasementHeatingRoom' },
  { label: i18next.t('gateway_placement.hallway', { ns: 'enums' }), value: 'Hallway' },
  { label: i18next.t('gateway_placement.entrance', { ns: 'enums' }), value: 'Entrance' },
  { label: i18next.t('gateway_placement.main_staircase', { ns: 'enums' }), value: 'MainStaircase' },
  { label: i18next.t('gateway_placement.attic', { ns: 'enums' }), value: 'Attic' },
  { label: i18next.t('gateway_placement.other', { ns: 'enums' }), value: 'Other' },
];
